import type { FaireProductEntity } from "../../entity_types/product";

export const p_767y9wz68u: FaireProductEntity = {
  token: "p_767y9wz68u",
  type: "product",
  name: "18k Gold Plated Herringbone flat necklace chain",
  brandToken: "b_64gjnxjyb8",
  brandName: "Karrbear",
  imageUrl:
    "https://cdn.faire.com/fastly/2be57e27ab7febecb9c3939bc5338b17e496f328fc48b3a356fcc97f29ee4d3d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dcd26cc449f47bee95de30ba2a8bbff9702eac6232845190cfd5f8d2d66b237d.jpeg",
    "https://cdn.faire.com/fastly/ac56a774313227a07a5d0a85833a8e8115d51dc89c1328a8e3c8ea75b9cbe30f.jpeg",
    "https://cdn.faire.com/fastly/810fa934ec188c6e41c71d47cafab12e964b2ebbddb445b2176a35f5ff4ebf88.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "18k Gold Plated Herringbone flat necklace chain\nLength 8'' 10''16'' 18''20''24''",
  tags: [],
  msrpDollars: 55.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:48.927Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
